import {useEffect, useContext } from 'react';
import axios from 'axios';
import { useAuth } from '../../Authentification/Auth';
import { IdBCContext } from '../../IdBCContext';
import API_BASE_URL from '../config';

const AppelAPIBilanMoto = ({setLancer, Lancer, setApiResponse, save}) => {
  const { token, isTokenExpired } = useAuth();
  const { idBC } = useContext(IdBCContext);

  useEffect(() => {
    isTokenExpired()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  
  useEffect(() => {
    // Vérifier si le token est disponible avant de faire la requête
    if (token && Lancer) { 
       fetchData();
     }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, Lancer]); // Se ré-exécute lorsque `token` change

   const fetchData = async () => {
    const apiUrl = `${API_BASE_URL}/aps_Pmoto_Total`;
    
    const data = {
      IdBC: idBC,
      save: save
    };

    const options = {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    };
    
    try {
      const result = await axios.post(apiUrl, data, options);
       // Mettre à jour la réponse de l'API dans le composant parent
       setApiResponse(result.data);
       setLancer(false);

    } catch (error) {
      console.error("Erreur lors de l'envoi de la requête :", error);
    } finally {
    }
  };
  return (null);
};

export default AppelAPIBilanMoto;
